import { render, staticRenderFns } from "./Locality.vue?vue&type=template&id=07b0db91"
import script from "./Locality.vue?vue&type=script&lang=js"
export * from "./Locality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports